import { Bucket } from '../types';

/**
 * Single source of truth for "is this bucket over budget" — used by both the
 * categories-list group-header "N over" chip and the budgets-page
 * "Only over budget" filter so the two can never disagree.
 *
 * `excludedFromSpendingReports` deliberately does NOT suppress this signal.
 * Over budget answers "do I need to act?", which is an alert, not a report:
 * the bucket's row already renders red, so hiding it from the chip and the
 * "Only over budget" filter would make the problem the user just saw vanish
 * the moment they filtered for problems. Exclusion changes the reports, not
 * the alerts — the same reasoning that keeps excluded money in the planning
 * total. Don't "re-fix" this by adding the clause back.
 */
export function isOverBudgetBucket(bucket: Bucket): boolean {
  if (bucket.type === 'INCOME' || bucket.type === 'TRANSFERS') return false;
  const fundBalance = bucket.fund?.balance;
  const remaining = fundBalance !== undefined ? fundBalance : bucket.amount + bucket.total;
  return remaining < 0;
}
